import { parseHexString } from "@mm/color-lib";

export const isValidColorValue = (value: string): boolean => {
  const trimmed = value.trim();
  if (trimmed.length === 0) {
    return false;
  }
  if (parseHexString(trimmed)) {
    return true;
  }

  const rgbaMatch = trimmed.replace(/\s+/g, "").match(/^rgba?\(([^)]+)\)$/i);
  if (!rgbaMatch) {
    return false;
  }

  const parts = rgbaMatch[1].split(",");
  if (parts.length !== 3 && parts.length !== 4) {
    return false;
  }

  const toUnit = (raw: string, channelIndex: number): number => {
    const n = Number(raw);
    if (!Number.isFinite(n)) {
      return Number.NaN;
    }
    if (channelIndex < 3) {
      if (n <= 1) {
        return Math.min(Math.max(n, 0), 1);
      }
      return Math.min(Math.max(n / 255, 0), 1);
    }
    return Math.min(Math.max(n, 0), 1);
  };

  const r = toUnit(parts[0], 0);
  const g = toUnit(parts[1], 1);
  const b = toUnit(parts[2], 2);
  const a = parts[3] == null ? 1 : toUnit(parts[3], 3);

  return Number.isFinite(r) && Number.isFinite(g) && Number.isFinite(b) && Number.isFinite(a);
};
